import {request} from './request';

export default {
    async checkHealth()
    {
        const rv = await request({
            url: 'api/check-health',
            method: 'get'
        });

        return rv;
    }
}